<template>
    <vx-card class="limited-max-width" id="ss-fourth-step">
      <div>
        <header-step-process-component
          v-bind:step="step">
        </header-step-process-component>

        <span class="title-style modify-title" style="display:inline-block; margin-bottom:8px">Estos son los capitales que te recomendamos.</span>
        <span class="subtitle-style modify-subtitle" style="display:inline-block; opacity: 0.7;">Si quieres puedes ajustarlos, según el precio que quieras pagar.</span>

        <!-- <span class="subtitle-style modify-subtitle" style="display:inline-block; opacity: 0.7;">Si quieres modificarlos, puedes hacerlo con las barras de la derecha.</span> -->

        <negotation-social-security

          v-bind:code="code"
          v-bind:next="next"
          v-bind:previus="previus"
          >
        </negotation-social-security>
      </div>
    </vx-card>
</template>

<script>
/* eslint-disable */
import VxCard from '../../components/vx-card/VxCard.vue'
import HeaderStepProcessComponent from '../components/eprevision-components/header/HeaderStepProcessComponent.vue';
import NegotationSocialSecurity from '../components/eprevision-components/NegotationSocialSecurity/NegotationSocialSecurity.vue';
export default {
  components: {
      VxCard,
      HeaderStepProcessComponent,
      NegotationSocialSecurity
    },
    data() {
      return {
        step: 2,
        code: this.$route.params.code,
        next: "social-security/fifth",
        previus: "social-security/third",

      }
    },
    created() {
      this.$vs.loading.close()

    },
    methods: {

      
    }


}
</script>

 <style lang="scss">

</style>